import axios from "api/client";
export default {
  upload: (image) => axios.post(`/media`, { image }),
};
